import React from "react";
import {PromoItemsDto} from "../../../../dtos";
import styles from './TooltipDetailsItemPopup.module.scss';
import {AsyncImageWithLoader} from "../../../../com/imageWithLoader/imageWithLoader";
import {OrangeButton} from "../../pagesTab/orangeBtn/OrangeButton";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {NonImagePlaceholder} from "../../nonImagePlaceholder/nonImagePlaceholder";

interface Props {
    item: PromoItemsDto,
    editItem: (e: React.MouseEvent<HTMLElement>) => void;
}


export const TooltipDetailsItemPopup: React.FC<Props> = (
    {
        item,
        editItem
    }
) => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const isDisableEditBtn = flyerDetailsState.flyFstRec.fstCaption === "Published";

    return (
        <div className={`${styles.item_tooltip_details_popup} layout_flex_row`}>
            <div>
                <div className={`layout_flex_row ${styles.row_with_image}`}>
                    <div className={styles.image_wrapper}>
                        <AsyncImageWithLoader src={item.fpiImage ? item.fpiImage : ''} notUploadIcon={<NonImagePlaceholder/>}/>
                    </div>
                </div>

            </div>
            <div>
                <div className={`layout_flex_column ${styles.row} ${item.fpiCode?.length ? '' : styles.missing_property}`}>
                    <div>
                        Item Code
                    </div>
                    <div className={`${styles.value_for_prop}`} title={item.fpiCode}>
                        {item.fpiCode?.length ? item.fpiCode : `Info is missing`}
                    </div>
                </div>
                <div className={`layout_flex_column ${styles.row} ${item.fpiDisplayCaption1 ? '' : styles.missing_property}`}>
                    <div>
                        Item Caption
                    </div>
                    <div className={`${styles.value_for_prop}`} title={item.fpiDisplayCaption1}>
                        {item.fpiDisplayCaption1 ? item.fpiDisplayCaption1: `Info is missing` }
                    </div>
                </div>
                {
                    flyerDetailsState.flyFltRec.fltCode !== 3 &&
                    <div className={`layout_flex_column ${styles.row} ${item.fpiRegularPrice ? '' : styles.missing_property} `}>
                        <div>
                            Price
                        </div>
                        <div className={`${styles.value_for_prop}`} title={item.fpiRegularPrice}>
                            {flyerDetailsState.flyLacRec.lacCurrencySymbol} {item.fpiRegularPrice ? item.fpiRegularPrice.toFixed(2): `Info is missing`}
                        </div>
                    </div>
                }
                <div className={`layout_flex_row ${styles.button_wrapper}`}>
                    <OrangeButton buttonName={`EDIT`} onClick={editItem} isDisabled={isDisableEditBtn}/>
                </div>
            </div>
        </div>
    )
}